<template>
  <div
    class="border border-custom-lightgray col-span-12 md:col-span-6 hover:border-custom-lightblue md:transform hover:scale-105 transition duration-500 rounded hover:shadow-2xl"
  >
    <div class="md:text-xl px-5 py-8 ">
      <h1 class="text-2xl md:text-3xl pb-10">
        Drug Activity happened inside the park today
      </h1>
      <img
        class="inline w-11 h-11 rounded-full"
        src="/assets/user2.png"
        alt="userimage"
      />
      <p class="inline px-5 font-semibold ">Stephen Baker</p>
      <p class="float-right mt-2 text-custom-lightgray">18 Dec 2020</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
